module.exports = __webpack_public_path__ + "img/front_39.72b19185.svg";